export default __webpack_public_path__ + "static/media/banner-9.406d6626.jpg";